export const groupOptions =     [
    {label: 'Grupo 1 - Arma Curta Uso Permitido', value: '1', restricted: 0},
    {label: 'Grupo 2 - Arma Longa Raiada Uso Permitido', value: '2', restricted: 0},
    {label: 'Grupo 3 - Arma Longa Lisa Uso Permitido', value: '3', restricted: 0},
    {label: 'Grupo 4 - Arma Curta Uso Restrito', value: '4', restricted: 1},
    {label: 'Grupo 5 - Arma Longa Raiada Uso Restrito', value: '5', restricted: 1},
    {label: 'Grupo 6 - Arma Longa Lisa Uso Restrito', value: '6', restricted: 1}]
